import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useMe } from "@/shared/lib/auth";

/**
 * Wraps public auth pages (login/signup). If a session already exists, sends the
 * user to /app/contacts instead of showing the form. Uses `replace` so the back
 * button doesn't bounce back onto the auth page.
 *
 * Intentionally does NOT gate on me.isLoading: while loading, me.data is falsy so
 * the form renders immediately for the common (unauthenticated) visitor — no
 * spinner flash. An already-authed user sees the form for one frame before the
 * redirect, which is acceptable for this rare path.
 */
export function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const me = useMe();
  if (me.data) return <Navigate to="/app/contacts" replace />;
  return <>{children}</>;
}
